var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 38.342l-3.523-3.524 6.49-6.49 3.523 3.523-6.49 6.49z",
    fill: "url(#search_svg__paint0_linear_1242_141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 38.34l-3.523-3.523a1.932 1.932 0 000 2.733l.791.79a1.932 1.932 0 002.732 0z",
    fill: "url(#search_svg__paint1_linear_1242_141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.066 29.569v6.89l4.606-4.608-3.523-3.523-1.162 1.162.079.079z",
    fill: "url(#search_svg__paint2_linear_1242_141)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.431 32.934l-3.366-3.366a1.167 1.167 0 010-1.65l.919-.919L23 32.016l-.918.918a1.167 1.167 0 01-1.65 0z",
    fill: "url(#search_svg__paint3_linear_1242_141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.984 26.999l-.166.166v3.155l2.613 2.614a1.167 1.167 0 001.651 0l.918-.918-5.016-5.017z",
    fill: "url(#search_svg__paint4_linear_1242_141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 33.354C33.996 33.354 39 28.35 39 22.177S33.996 11 27.823 11c-6.172 0-11.177 5.004-11.177 11.177s5.005 11.177 11.177 11.177z",
    fill: "url(#search_svg__paint5_linear_1242_141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 31.586a9.409 9.409 0 100-18.817 9.409 9.409 0 000 18.817z",
    fill: "url(#search_svg__paint6_linear_1242_141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 30.23a8.054 8.054 0 100-16.107 8.054 8.054 0 000 16.107z",
    fill: "url(#search_svg__paint7_linear_1242_141)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.487 38.797l-3.284-3.284a.692.692 0 11.978-.978l3.284 3.284a.692.692 0 11-.978.978z",
    fill: "url(#search_svg__paint8_linear_1242_141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.719 15.246v.511c0 .388-.191.562-.506.562-.26 0-.432-.119-.484-.38-.207.17-.407.35-.6.544l-.085.085c.24.366.668.515 1.169.515.775 0 1.383-.36 1.383-1.326v-.96c-.3.13-.592.28-.877.449zM25.984 14.335v2.444c0 .18.219.27.438.27.22 0 .439-.09.439-.27v-2.598a7.947 7.947 0 00-.877.154zM29.85 14.382v1.375c0 .387-.19.562-.505.562-.314 0-.5-.175-.5-.562v-1.49c0-.027.001-.053.003-.078a7.908 7.908 0 00-.875-.064 1.988 1.988 0 00-.005.142v1.49c0 .967.601 1.326 1.377 1.326s1.383-.36 1.383-1.326v-1.094a7.958 7.958 0 00-.877-.281zM32.116 15.361v1.418c0 .18.22.27.439.27s.438-.09.438-.27v-.778a7.922 7.922 0 00-.877-.64zM21.108 17.73c-.18.268-.34.546-.483.83a.53.53 0 01.294-.074c.315 0 .506.174.506.562v1.49c0 .387-.191.561-.506.561-.314 0-.5-.174-.5-.561v-1.49l.001-.047a8.052 8.052 0 00-.615 2.422c.247.312.65.441 1.114.441.776 0 1.383-.36 1.383-1.326v-1.49c0-.887-.511-1.262-1.194-1.318zM24.18 17.71a.307.307 0 00-.164.04l-.742.45a.335.335 0 00-.163.297c0 .174.113.348.276.348.039 0 .09-.01.14-.045l.163-.1v2.86c0 .18.22.27.439.27s.438-.09.438-.27v-3.574c0-.169-.208-.276-.388-.276zM27.052 17.722c-.776 0-1.377.36-1.377 1.326v1.49c0 .966.601 1.326 1.377 1.326s1.382-.36 1.382-1.326v-1.49c0-.967-.607-1.326-1.382-1.326zm.505 2.816c0 .387-.19.561-.505.561s-.5-.174-.5-.561v-1.49c0-.388.185-.562.5-.562.314 0 .505.174.505.562v1.49zM30.312 17.71a.306.306 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .174.113.348.275.348.04 0 .09-.01.14-.045l.164-.1v2.86c0 .18.22.27.439.27.218 0 .438-.09.438-.27v-3.574c0-.169-.208-.276-.388-.276zM33.184 17.722c-.776 0-1.377.36-1.377 1.326v1.49c0 .966.601 1.326 1.377 1.326.775 0 1.383-.36 1.383-1.326v-1.49c0-.967-.608-1.326-1.383-1.326zm.506 2.816c0 .387-.191.561-.506.561s-.5-.174-.5-.561v-1.49c0-.388.185-.562.5-.562s.506.174.506.562v1.49zM20.34 22.491a.301.301 0 00-.163.04l-.386.234a8.031 8.031 0 00.937 3.228v-3.226c0-.169-.208-.276-.387-.276zM23.212 22.502c-.775 0-1.377.36-1.377 1.327v1.49c0 .966.602 1.326 1.377 1.326.776 0 1.383-.36 1.383-1.327v-1.49c0-.966-.607-1.326-1.383-1.326zm.507 2.816c0 .388-.192.562-.507.562-.314 0-.5-.174-.5-.562v-1.49c0-.387.186-.561.5-.561.316 0 .507.174.507.562v1.49zM26.473 22.491a.3.3 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .175.112.349.275.349.04 0 .09-.011.14-.045l.164-.102v2.861c0 .18.22.27.438.27.22 0 .439-.09.439-.27v-3.574c0-.169-.208-.276-.388-.276zM29.345 22.502c-.776 0-1.377.36-1.377 1.327v1.49c0 .966.601 1.326 1.377 1.326s1.383-.36 1.383-1.327v-1.49c0-.966-.607-1.326-1.383-1.326zm.506 2.816c0 .388-.191.562-.506.562-.314 0-.5-.174-.5-.562v-1.49c0-.387.186-.561.5-.561.315 0 .506.174.506.562v1.49zM32.605 22.491a.301.301 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .175.113.349.276.349.039 0 .09-.011.14-.045l.163-.102v2.861c0 .18.22.27.438.27.22 0 .439-.09.439-.27v-3.574c0-.169-.208-.276-.388-.276zM35.478 22.502c-.776 0-1.378.36-1.378 1.327v1.49c0 .575.214.936.55 1.133.156-.246.296-.498.42-.756a.665.665 0 01-.093-.378v-1.49c0-.387.185-.561.5-.561.126 0 .233.028.315.086.04-.27.065-.543.077-.816a2.04 2.04 0 00-.391-.035zM21.768 27.487c.115.132.235.26.36.385l.018.018a1.011 1.011 0 00-.378-.403zM24.18 27.271a.303.303 0 00-.164.04l-.742.45a.334.334 0 00-.163.297c0 .175.113.349.276.349.039 0 .09-.012.14-.045l.163-.101v.83c.285.171.578.323.877.454v-1.998c0-.169-.208-.276-.388-.276zM27.052 27.283c-.776 0-1.377.36-1.377 1.327v1.331c.29.08.582.143.877.19v-1.522c0-.387.185-.561.5-.561.314 0 .505.174.505.562v1.49c0 .045-.002.087-.007.127.293.01.588.004.881-.019a2.27 2.27 0 00.003-.109v-1.49c0-.966-.607-1.326-1.382-1.326zM30.312 27.271a.301.301 0 00-.163.04l-.742.45a.334.334 0 00-.163.297c0 .175.113.349.275.349.04 0 .09-.012.14-.045l.164-.101v1.719a8.05 8.05 0 00.877-.279v-2.154c0-.169-.208-.276-.388-.276zM33.184 27.283c-.776 0-1.377.36-1.377 1.327v.57c.302-.172.594-.365.876-.58.004-.38.189-.552.501-.552a.74.74 0 01.139.013 8.122 8.122 0 00.605-.63 1.72 1.72 0 00-.744-.148z",
    fill: "#E63950"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint0_linear_1242_141",
    x1: 16.093,
    y1: 32.776,
    x2: 18.495,
    y2: 35.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint1_linear_1242_141",
    x1: 12.143,
    y1: 37.857,
    x2: 12.73,
    y2: 37.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint2_linear_1242_141",
    x1: 17.335,
    y1: 33.818,
    x2: 21.684,
    y2: 26.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07485E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint3_linear_1242_141",
    x1: 19.855,
    y1: 27.547,
    x2: 19.855,
    y2: 33.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint4_linear_1242_141",
    x1: 18.702,
    y1: 31.297,
    x2: 20.898,
    y2: 29.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint5_linear_1242_141",
    x1: 27.815,
    y1: 12.935,
    x2: 27.815,
    y2: 33.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint6_linear_1242_141",
    x1: 27.796,
    y1: 29.948,
    x2: 27.796,
    y2: 12.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint7_linear_1242_141",
    x1: 27.815,
    y1: 15.52,
    x2: 27.815,
    y2: 30.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint8_linear_1242_141",
    x1: 13.904,
    y1: 36.096,
    x2: 12.58,
    y2: 37.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })))));
}
export default "/_next/static/media/search.987f9a067607e38ba8dff3015344e2f0.svg";
export { SvgSearch as ReactComponent };